import posthog from 'posthog-js';

const POSTHOG_PROJECT_TOKEN = 'phc_rjMg7eyL4wxhDjfnbgrdMj3wpLu37iQzv893qZq2v545';
const POSTHOG_API_HOST = 'https://us.i.posthog.com';
const POSTHOG_UI_HOST = 'https://us.posthog.com';

let isInitialized = false;

export function initAnalytics() {
  if (typeof window === 'undefined' || isInitialized || process.env.NODE_ENV === 'test') {
    return;
  }

  posthog.init(POSTHOG_PROJECT_TOKEN, {
    api_host: POSTHOG_API_HOST,
    ui_host: POSTHOG_UI_HOST,
    defaults: '2025-05-24',
    autocapture: true,
    capture_pageview: false,
    capture_pageleave: true,
    capture_dead_clicks: true,
    capture_exceptions: true,
    capture_performance: {
      network_timing: true,
      web_vitals: true,
    },
    persistence: 'localStorage+cookie',
    loaded: (posthogInstance) => {
      if (process.env.NODE_ENV === 'development') {
        posthogInstance.debug();
      }
    },
  });

  isInitialized = true;
}

export function capturePageView(location) {
  if (!isInitialized || typeof window === 'undefined') {
    return;
  }

  posthog.capture('$pageview', {
    $current_url: window.location.href,
    path: `${location.pathname}${location.search}${location.hash}`,
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
    title: document.title,
  });
}

export function captureLinkClick(link) {
  if (!isInitialized || typeof window === 'undefined') {
    return;
  }

  posthog.capture('link_clicked', {
    href: link.href,
    label: link.innerText.trim() || link.getAttribute('aria-label') || link.title || link.href,
    target: link.target || '_self',
    pathname: window.location.pathname,
    current_url: window.location.href,
  });
}
